__turbopack_context__.v({
  "className": "jetbrains_mono_e82f144f-module__ATfDjG__className",
  "variable": "jetbrains_mono_e82f144f-module__ATfDjG__variable",
});
